import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import Button from '@saucelabs/ds-button';
import Modal, { ModalProvider } from '@saucelabs/ds-modal';

import { CREDIT_REFRESH_MODAL_KEY } from '../../constants';

const ModalComponent = ({ onConfirm }) => (
  <Modal
    emphasis="low"
  >
    <div className="flex flex-col items-center mb-4 mt-0 px-0 py-0">
      <h1 className="mb-0 mt-0 px-0 py-0">🕺💃</h1>
      <p className="mb-0 mt-1 font-semibold text-xl">We just refilled your account with 2000 credits!</p>
      <p className="mb-0 mt-0 font-semibold text-xl">Happy testing!</p>
    </div>
    <hr className="mx-2 my-2" />
    <div className="flex flex-col items-center mb-2">
      <p className="mb-1.5 text-base">Need more testing minutes? Check out our starter package.</p>
      <Button
        className="px-12"
        color="primary"
        onPress={onConfirm}
        size="md"
      >
        Buy the starter package ($50.00)
      </Button>
    </div>
  </Modal>
);

const ConnectedModal = modalConnectV2(CREDIT_REFRESH_MODAL_KEY, ModalComponent);

const CreditRefreshModal = ({ credits, showModal, hideModal, userId }) => {
  // Stores the time the modal was shown in UTC in local storage
  const LOCAL_STORAGE_MODAL_SHOWN_KEY = `${userId}:CREDIT_REFRESH_MODAL_SHOWN`;

  useEffect(() => {
    // Iterate through credit grants and filter for freemium credit grants only
    const freemiumRefill = credits?.available_credits?.filter((credit) => credit.source === 'freemium_refill')[0];
    if (freemiumRefill) {
      const latestCreditGrantDate = Date.parse(freemiumRefill.grant_time);
      // Check to see if we have not already shown this update to the user or if we need to
      if (!localStorage.getItem(LOCAL_STORAGE_MODAL_SHOWN_KEY) ||
          latestCreditGrantDate > localStorage.getItem(LOCAL_STORAGE_MODAL_SHOWN_KEY)) {
        // Show modal and store the latest grant time
        localStorage.setItem(LOCAL_STORAGE_MODAL_SHOWN_KEY, latestCreditGrantDate);
        showModal();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credits]);

  const history = useHistory();

  // Push to billing page on button press
  const onConfirm = () => {
    history.push('/billing');
    hideModal();
  };

  return (
    <ModalProvider>
      <ConnectedModal
        onConfirm={onConfirm}
      />
    </ModalProvider>
  );
};

ModalComponent.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

CreditRefreshModal.propTypes = {
  credits: PropTypes.shape({
    available_credits: PropTypes.arrayOf(
      PropTypes.shape({
        credits: PropTypes.number.isRequired,
        expiration_time: PropTypes.string.isRequired,
        grant_time: PropTypes.string.isRequired,
        source: PropTypes.string.isRequired,
      }),
    ),
  }),
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
};

CreditRefreshModal.defaultProps = {
  credits: null,
};

export default CreditRefreshModal;
